<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-statement-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <mat-sidenav-container>
    <mat-sidenav
      #previewPane
      [fixedInViewport]="true"
      mode="side"
      position="end"
      mode="over"
      (closed)="closePreviewPane()"
      class="max-w-full">
      <sbnb-statement-detail-customize
        *ngIf="statement$ | async as statement"
        [data]="{
          propertyId: statement.property.id,
          propertyName: statement.property.name,
          statementId: statementId
        }"
        (closed)="closePreviewPane()"></sbnb-statement-detail-customize>
    </mat-sidenav>
    <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
      <sbnb-loading-spinner *ngIf="loading$ | async"></sbnb-loading-spinner>
      <div *ngIf="statement$ | async as statement" class="w-full">
        <div class="flex items-center gap-2 pb-4 mb-8 border-b border-smoke relative flex-wrap">
          <app-feature-flag-tabs class="w-full md:w-auto md:flex-1">
            <ng-container navTabs>
              <sbnb-page-header class="absolute top-0 left-0"></sbnb-page-header>
              <div class="flex gap-3 flex-1 items-center justify-center sbnbDesktop:justify-start">
                <h2 class="!mb-0">{{ statement.type ? (statement.type | humanize) : 'Statement' }} detail</h2>
              </div>
            </ng-container>

            <div class="flex gap-3 flex-1 items-center">
              <sbnb-back-button [iconOnly]="true"></sbnb-back-button>
              <h2 class="!mb-0">{{ statement.type ? (statement.type | humanize) : 'Statement' }} detail</h2>
            </div>
          </app-feature-flag-tabs>
          <ng-container *ngFor="let action of statement.actions">
            <sbnb-button
              *ngIf="action.type === 'customize'"
              type="secondary"
              size="mini"
              label="Customize"
              (clicked)="openCustomizeDrawer()"
              icon="settings"></sbnb-button>
            <sbnb-button
              *ngIf="action.type === 'download_pdf_url'"
              [loading]="downloading$ | async"
              [icon]="'download'"
              size="mini"
              label="Download"
              (clicked)="downloadStatement()"></sbnb-button>
            <sbnb-button
              *ngIf="action.type === 'preview_pdf'"
              [loading]="downloadingPreview$ | async"
              size="mini"
              label="Preview"
              (clicked)="downloadPreview()"></sbnb-button>
            <sbnb-button
              *ngIf="action.type === 'publish_statement'"
              [loading]="publishing$ | async"
              size="mini"
              label="Publish"
              [disabled]="!action.enabled"
              [matTooltip]="action.description"
              (clicked)="publishStatement()"></sbnb-button>
            <sbnb-button
              *ngIf="action.type === 'unpublish_statement'"
              [loading]="unpublishing$ | async"
              type="secondary"
              size="mini"
              label="Unpublish"
              (clicked)="unpublishStatement(statement.type)"
              [disabled]="!action.enabled"
              [matTooltip]="action.description"></sbnb-button>
            <sbnb-button
              *ngIf="action.type === 'mark_as_paid'"
              [loading]="unpublishing$ | async"
              type="secondary"
              size="mini"
              label="Mark as paid"
              (clicked)="markAsPaid(statement.type)"
              [disabled]="!action.enabled"
              [matTooltip]="action.description"></sbnb-button>
          </ng-container>
        </div>

        <section id="statement-detail" class="relative">
          <div class="text-left md:text-center mt-4 mb-12 md:mt-0 flex flex-col gap-2">
            <h3 class="text-xl font-bold">
              <div>{{ statement.headline.title }}</div>
              <div *ngFor="let subtitle of statement.headline.subtitles">{{ subtitle }}</div>
            </h3>

            <sbnb-cs-debug-item
              class="text-sm"
              label="Statement"
              [coreNovaLink]="'/resources/statements/' + statementId"
              [value]="statementId"
              linkLabel="Nova" />
          </div>

          <div class="flex gap-4 flex-col md:flex-row justify-between">
            <div class="manager-details border rounded border-smoke border-solid p-4 w-96 relative">
              <h4 class="absolute -top-[17px] bg-white p-2">Manager</h4>
              <div class="flex flex-col gap-4 mt-2">
                <div class="flex gap-4">
                  <img
                    *ngIf="
                      statement.manager.brand_logo_url &&
                      statement.customizations.brand_settings.includes(BrandSettingsCustomizationOptions.BrandInfo)
                    "
                    [src]="statement.manager.brand_logo_url"
                    alt="Manager Logo"
                    class="w-20" />
                  <div class="flex flex-col gap-1">
                    <span
                      *ngIf="
                        statement.manager.brand_logo_url &&
                        statement.customizations.brand_settings.includes(BrandSettingsCustomizationOptions.BrandInfo)
                      "
                      class="text-lg">
                      {{ statement.manager.brand_name }}
                    </span>
                    <ng-container
                      *ngIf="
                        statement.customizations.brand_settings.includes(BrandSettingsCustomizationOptions.PersonalInfo)
                      ">
                      <div>{{ statement.manager.name }}</div>
                      <div *ngIf="statement.manager.company_name">{{ statement.manager.company_name }}</div>
                      <div>{{ statement.manager.address_label }}</div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="owner-details border rounded border-smoke border-solid p-4 w-96 relative">
              <h4 class="absolute -top-[17px] bg-white p-2">Owner</h4>
              <div>{{ statement.owner.name }}</div>
              <div>{{ statement.owner.address_label }}</div>
            </div>
          </div>
          <div>
            <div *ngFor="let table of statement.tables" class="mt-12">
              <div class="flex">
                <div class="flex-1">
                  <h3>{{ table.title }}</h3>
                  <div class="text-sm mb-4">{{ table.subtitle }}</div>
                </div>
                <ng-container *ngFor="let action of table.actions">
                  <button *ngIf="action === 'add_transaction'" class="button__small" mat-flat-button>
                    <a [routerLink]="['/operations/my-business/transactions/add']">Add transaction</a>
                  </button>
                </ng-container>
              </div>

              <div
                *ngIf="
                  (table.title === 'Reservations' && table.rows?.length > 2) ||
                    (table.title !== 'Reservations' && table.rows?.length > 1);
                  else noTableDataTemplate
                ">
                <div class="overflow-x-auto">
                  <table class="w-full border-collapse min-w-[1000px] table-auto">
                    <tr
                      *ngFor="let row of table.rows; let ri = index"
                      class="border-b border-smoke"
                      [routerLink]="row.id ? ['/operations/my-business/transactions', row.id] : null"
                      [ngClass]="{
                        'hover:bg-smoke-lighter cursor-pointer': row.id,
                        'whitespace-nowrap': row.type === 'normal'
                      }">
                      <td
                        *ngFor="let column of row.columns; let i = index"
                        class="py-2 px-2 last:border-r border-smoke text-sm"
                        [ngClass]="{
                          'bg-smoke-lighter': (row.color === 'grey' && !!column.value) || row.color === 'lightest',
                          border: !!column.value && ri === 0,
                          'bg-smoke': row.color === 'dark',
                          'font-bold': !!row.color,
                          'border-l': column.divider,
                          'text-left': column.alignment === 'left',
                          'text-right': column.alignment === 'right',
                          'font-serif': column.format === 'numeric'
                        }"
                        [attr.colspan]="column.span">
                        <ng-container *ngIf="column.url; else plainValue">
                          <a [href]="column.url" class="text-primary hover:underline">{{ column.value }}</a>
                        </ng-container>
                        <ng-template #plainValue>
                          {{ column.value }}
                        </ng-template>
                      </td>
                    </tr>
                  </table>
                </div>
                <ng-container *ngIf="table.notes">
                  <ul class="list-disc pl-6">
                    <li class="text-sm my-1" *ngFor="let note of table.notes | keyvalue">
                      <strong>{{ note.key }}:</strong>
                      {{ note.value }}
                    </li>
                  </ul>
                </ng-container>
              </div>
              <ng-template #noTableDataTemplate>
                <sbnb-no-items
                  icon="subtotal"
                  [text]="
                    table.title === 'Reservations'
                      ? 'There is no reservation revenue to report for this month.'
                      : 'There are no transactions to report for this month.'
                  "></sbnb-no-items>
              </ng-template>
            </div>
          </div>

          <!-- Adjustments -->
          <ng-container *ngIf="adjustmentsState$ | async as adjustmentsState">
            <div class="mt-12" *ngIf="adjustmentsState.data?.length">
              <h3>Adjustments</h3>
              <sbnb-adjustments-table
                [previewedAdjustment]="previewedAdjustment$ | async"
                (adjustmentSelected)="onAdjustmentSelected($event)"
                (adjustmentApplied)="onAdjustmentApplied()"></sbnb-adjustments-table>
            </div>
          </ng-container>

          <div>
            <div class="flex flex-col md:flex-row gap-8 mt-8">
              <div class="flex-1">
                <sbnb-textarea
                  [matTooltip]="cannotEditNote$ | async"
                  class="w-full"
                  placeholder="Notes..."
                  maxlength="500"
                  type="text"
                  [formControl]="note"></sbnb-textarea>

                <div class="mt-2">
                  <sbnb-save-indicator [saveStatus]="saveStatus$ | async"></sbnb-save-indicator>
                </div>
              </div>
              <div class="flex-1" *ngIf="statement.summary && statement.summary.length > 0">
                <div class="flex justify-end mr-4">
                  <div class="statement-headline flex flex-col gap-2">
                    <div
                      *ngFor="let item of statement.summary; let last = last"
                      class="flex items-end justify-between gap-6">
                      <h4 class="font-bold text-grape-darker" [class.text-2xl]="last">{{ item.title }}</h4>
                      <h4 class="text-right w-32 text-grape-darker" [class.text-2xl]="last">{{ item.value }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="statement.attachments?.length" class="flex-1 mt-12 mb-40">
            <h3>Attachments</h3>

            <ul class="list pt-3">
              <li *ngFor="let attachment of statement.attachments; let i = index">
                <a
                  target="_blank"
                  (click)="attachment.endsWith('/download') ? downloadAttachment(attachment) : null"
                  [href]="!attachment.endsWith('/download') ? attachment : null"
                  class="link flex items-center gap-2"
                  data-attachment-index="{{ i }}">
                  Attachment {{ i + 1 }}
                  <mat-icon inline="true" class="no-underline">open_in_new</mat-icon>
                </a>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </main>
  </mat-sidenav-container>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
